// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"c8a4f194","598":"d6ef2c75","787":"46669eae"}[chunkId] + ".chunk.js";
};